import React from "react";
import Layout from "../../components/Layout/Layout";
import Help from "../../components/Help/Help";

const Ayuda = (props) => {
  return (
    <Layout>
      <Help />
    </Layout>
  );
};

export default Ayuda;
